<template>
  <transition name="el-fade-in-linear">
    <router-view/>
  </transition>
</template>

<script>
import Cookies from 'js-cookie'
import { messages } from '@/i18n'

export default {
  data () {
    return {
      sysType: window.SITE_CONFIG['sys_type']
    }
  },
  watch: {
    sysType () {
      this.$store.state.sysType = this.sysType
    },
    '$i18n.locale': 'i18nHandle',
  },
  created () {
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    i18nHandle (val, oldVal) {
      Cookies.set('language', val)
      document.querySelector('html').setAttribute('lang', val)
      // document.title = messages[val].brand.lg
      // 非登录页面，切换语言刷新页面
      if (this.$route.name !== 'login' && oldVal) {
        window.location.reload()
      }
    },
  },
}
</script>
<style lang="scss">
.app-content {
  min-height: calc(100vh - 50px);
  background-color: #fff;
}

.tox .tox-menu {
  z-index: 2020 !important;
}

.tox-tinymce-aux {
  z-index: 2020 !important;
}

.card-foot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 20px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
}

.m-card-head {
  height: 60px;
  padding: 0;
}

.query-btn-box {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 10px;
}

.query-label-box {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
}

.table-head {
  width: 100%;
  padding: 20px 0;
  display: flex;
  align-items: center;

  .label-wrapper {
    flex: none;
  }

  .btn-box {
    flex: auto;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
  }
}

.el-table {
  .el-table__cell {
    padding: 6px 0 !important;
  }
}

.txtBtn {
  padding: 6px 0px !important;
}

.page-box {
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.query-opt-bar {
  display: flex;
  margin-bottom: 8px;

  .el-button {
    margin-right: 10px;
  }
}

.query-form {
  .el-form-item {
    margin-bottom: 6px;
  }
}

.el-dialog__wrapper {
  .el-dialog__body {
    padding: 15px !important;
  }
}


.tg-table-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}
//表单底部操作栏
.form-foot{
  width: calc(100% - 165px);
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #fff;
  border-top: solid 1px #f5f7fa;
}
.pointer{
  cursor: pointer;
}
.bigicon{
  font-size: 18px;
  margin: 0 10px;
}
</style>
